import type { DocPackPage, DocPackPageWord } from '@listening/doc-pack';

export type DocPackTextPart =
  | { type: 'text'; text: string; key: string }
  | { type: 'word'; word: DocPackPageWord; key: string };

export const docPackCharRangesOverlap = (
  a: readonly [number, number],
  b: readonly [number, number],
) => a[0] < b[1] && b[0] < a[1];

export const splitDocPackRangeIntoParts = (
  page: DocPackPage,
  chars: readonly [number, number],
): readonly DocPackTextPart[] => {
  const parts: DocPackTextPart[] = [];
  let cursor = chars[0];

  for (const word of page.words) {
    if (!docPackCharRangesOverlap(word.chars, chars)) continue;
    if (cursor < word.chars[0]) {
      const text = page.text.slice(cursor, word.chars[0]);
      if (text) parts.push({ type: 'text', text, key: `t:${cursor}` });
    }
    parts.push({
      type: 'word',
      word,
      key: `w:${word.chars[0].toString()}-${word.chars[1].toString()}`,
    });
    cursor = Math.max(cursor, word.chars[1]);
  }

  if (cursor < chars[1]) {
    const text = page.text.slice(cursor, chars[1]);
    if (text) parts.push({ type: 'text', text, key: `t:${cursor}` });
  }

  if (parts.length === 0)
    return [
      { type: 'text', text: page.text.slice(chars[0], chars[1]), key: 't:all' },
    ];

  return parts;
};
